import React from 'react';
import { logger } from '@fiverr-private/obs';
import { LazyComponent } from '@fiverr-private/orca';

const IntroVideoModalLazy = (props) => {
    const lazyOnError = (error) => logger.error(error, { description: 'Failed to lazy load IntroVideoModal' });
    const lazyImport = () => import(
        /* webpackChunkName: 'IntroVideoModal' */ '.'
    );

    return (
        <LazyComponent lazyImport={lazyImport}
            shouldImport={true}
            componentProps={props}
            onError={lazyOnError}/>
    );
};

export default IntroVideoModalLazy;
